import ReactPaginate from 'react-paginate';
import React from 'react';

// @ts-ignore
import * as styles from './NumberedPagination.scss';

const NumberedPagination = props => {
  return <ReactPaginate
    className={styles.pagination}
    pageLinkClassName={styles.pagination__link}
    activeLinkClassName={styles['pagination__link--selected']}
    previousLinkClassName={styles['pagination__navigation-link']}
    nextLinkClassName={styles['pagination__navigation-link']}
    disabledLinkClassName={styles['pagination__navigation-link--disabled']}
    {...props}
  />;
};

export default NumberedPagination;
